import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Avatar, AvatarFallback, AvatarImage } from './ui/avatar';
import { Users, TrendingUp, Heart } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

const RightSidebar = () => {
  const [stats, setStats] = useState({ users: 0, posts: 0, active_today: 0 });

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const response = await axios.get(`${API}/api/stats`);
      setStats(response.data);
    } catch (error) {
      console.error('Error fetching stats:', error);
    }
  };

  return (
    <div className="space-y-6">
      {/* Community Stats */}
      <Card className="border-stone-200 rounded-2xl">
        <CardHeader className="pb-3">
          <CardTitle className="text-lg font-['Outfit'] text-stone-800">Community Stats</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-[#6B8E7B]/10 flex items-center justify-center">
              <Users className="h-5 w-5 text-[#6B8E7B]" />
            </div>
            <div>
              <p className="text-2xl font-bold text-stone-800">{stats.users}</p>
              <p className="text-sm text-stone-500">Nurses</p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-[#6B8E7B]/10 flex items-center justify-center">
              <TrendingUp className="h-5 w-5 text-[#6B8E7B]" />
            </div>
            <div>
              <p className="text-2xl font-bold text-stone-800">{stats.posts}</p>
              <p className="text-sm text-stone-500">Posts</p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-[#E27D60]/10 flex items-center justify-center">
              <Heart className="h-5 w-5 text-[#E27D60]" />
            </div>
            <div>
              <p className="text-2xl font-bold text-stone-800">{stats.active_today}</p>
              <p className="text-sm text-stone-500">Active Today</p>
            </div>
          </div>
        </CardContent>
      </Card>

      {/* About */}
      <Card className="border-stone-200 rounded-2xl">
        <CardHeader className="pb-3">
          <CardTitle className="text-lg font-['Outfit'] text-stone-800">About</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-stone-600 leading-relaxed">
            NurseCommunity is a safe space for nursing professionals to connect, share experiences, 
            and support each other. Whether you're celebrating a win or need to vent, we're here for you.
          </p>
          <div className="mt-4 pt-4 border-t border-stone-100">
            <p className="text-xs text-stone-400">
              NurseCommunity by Gina Rena
            </p>
            <a href="https://ginarena.com" target="_blank" rel="noopener noreferrer" className="text-xs text-[#6B8E7B] hover:underline">
              ginarena.com
            </a>
          </div>
        </CardContent>
      </Card>

      {/* Guidelines */}
      <Card className="border-stone-200 rounded-2xl">
        <CardHeader className="pb-3">
          <CardTitle className="text-lg font-['Outfit'] text-stone-800">Community Guidelines</CardTitle>
        </CardHeader>
        <CardContent>
          <ul className="text-sm text-stone-600 space-y-2">
            <li className="flex items-start gap-2">
              <span className="text-[#6B8E7B]">•</span>
              Be respectful and supportive
            </li>
            <li className="flex items-start gap-2">
              <span className="text-[#6B8E7B]">•</span>
              No patient identifiable information
            </li>
            <li className="flex items-start gap-2">
              <span className="text-[#6B8E7B]">•</span>
              Keep discussions professional
            </li>
            <li className="flex items-start gap-2">
              <span className="text-[#6B8E7B]">•</span>
              Anonymous posts stay anonymous
            </li>
          </ul>
        </CardContent>
      </Card>
    </div>
  );
};

export default RightSidebar;
